import { TriggerBusinessUnitSyncResponse } from "./types";
import axiosInstance from "../axiosInstance";

export const triggerBusinessUnitSync = async (
  companyUuid: string,
): Promise<TriggerBusinessUnitSyncResponse> => {
  const response = await axiosInstance.post<TriggerBusinessUnitSyncResponse>(
    `/api/private/companies/${companyUuid}/service-titan/business-units/sync`,
  );
  return response.data;
};
